module.exports = __webpack_public_path__ + "images/88c837effccc2b8364252472e79aa38e.jpg";